// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__Zhcpj","card":"styles_card__0_hyJ","spinner":"styles_spinner__xvKg2"};